import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'
import classNames from 'classnames'
import Sparkles from '../assets/Sparkles'

const PLACEHOLDER_TEXT = 'Ask Solo'

type Props = {
  clicked: (_initialMessage?: string) => void
}

function FastActionButton({ clicked }: Props) {
  const [inputValue, setInputValue] = React.useState('')
  const [isFocused, setIsFocused] = React.useState(false)
  const isSubmittingRef = React.useRef(false)
  const inputRef = React.useRef<HTMLInputElement>(null)

  const hasText = inputValue.trim().length > 0
  const isButtonDisabled = isFocused && !hasText

  const containerClassNames = classNames({
    'pilot-faw-button': true,
    'focused': isFocused,
    'has-text': hasText,
  })

  const buttonClassNames = classNames({
    'circle-btn': true,
    'disabled': isButtonDisabled,
  })

  const handleSubmit = () => {
    if (hasText) {
      clicked(inputValue.trim())
      setInputValue('')
      setIsFocused(false)
    }
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      handleSubmit()
    }
  }

  const handleContainerClick = (event: React.MouseEvent) => {
    if (event.target !== inputRef.current) {
      if (!isFocused) {
        setIsFocused(true)
      }
    }
  }

  const handleInputFocus = () => {
    setIsFocused(true)
  }

  const handleInputBlur = () => {
    if (!isSubmittingRef.current) {
      setIsFocused(false)
    }
  }

  const handleArrowClick = (event: React.MouseEvent) => {
    isSubmittingRef.current = true
    event.stopPropagation()
    event.preventDefault()
    handleSubmit()
    isSubmittingRef.current = false
  }

  React.useEffect(() => {
    if (isFocused && inputRef.current) {
      inputRef.current.focus()
    }
  }, [isFocused])

  return (
    <div className={containerClassNames} onClick={handleContainerClick}>
      {!isFocused && !inputValue ? (
        <div className='title'>
          <Sparkles />
          Ask Solo
        </div>
      ) : (
        <div className='input-section'>
          <Sparkles />
          <input
            ref={inputRef}
            type='text'
            value={inputValue}
            onChange={e => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
            placeholder={PLACEHOLDER_TEXT}
            className='pilot-faw-input'
          />
        </div>
      )}
      <div className='actions'>
        <div className={buttonClassNames} onMouseDown={handleArrowClick}>
          <FontAwesomeIcon icon={faArrowUp} />
        </div>
      </div>
    </div>
  )
}

export default FastActionButton
